import React from 'react'
import './assests/css/style.css';
import NewHeader from './components/NewHeader';
import imgurl from './assests/images/imgurl';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardActions';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";

function Result() {
    const navigate = useNavigate()

    const norwoodHamiltonStages = {
      "stage 2": {
          'description': "Stage 2 male pattern hair loss is marked by slight recession of the hairline around the temples, forming an adult or mature hairline. This stage is often not noticeable and is considered a normal part of aging.",
          'duration':'6 Months',
          'possibility':'75%'
      },
      "stage 3": {
          'description': "Stage 3 male pattern hair loss is marked by deep recession at the temples, forming an M, U, or V shape. The recessed areas are mostly bare, and this stage marks the beginning of clinically significant balding.",
          'duration':'6 Months',
          'possibility':'65%'
      },
      "stage 4": {
          'description': "Stage 4 male pattern hair loss is marked by severe hairline recession and significant hair loss on the top of the scalp (vertex). The two areas of hair loss are separated by a band of hair that connects to the hair remaining on the sides of the scalp.",
          'duration':'6 Months',
          'possibility':'45%'
      },
      "stage 5": {
          'description': "Stage 5 male pattern hair loss is marked by larger areas of hair loss at the temples and vertex, with a narrower and sparser band of hair between them. The hair loss is more extensive than in stage 4.",
          'duration':'6 Months',
          'possibility':'35%'
      },
      "stage 6": {
          'description': "Stage 6 male pattern hair loss is marked by the balding areas at the temples and vertex join, leaving little to no hair across the top of the head. The remaining hair forms a horseshoe shape around the sides and back of the head.",
          'duration':'6 Months',
          'possibility':'20%'
      },
      "stage 7": {
          'description': "Stage 7 male pattern hair loss is marked by the most severe stage, with only a thin band of hair remaining around the sides of the head. This hair is usually not dense and may be fine.",
          'duration':'6 Months',
          'possibility':'10%'
      }
  };
  let stage = JSON.parse(localStorage.getItem('stage'))
  // ['predicted_label'].split(' ');
  // console.log(stage,[stage[1] +" " +stage[2]],norwoodHamiltonStages[stage[1].toLowerCase() +stage[2]]['possibility']);
  
  function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  return (
    <div className="result">
         <NewHeader/>
         <div className="blue-shape2">
         <img src={imgurl.shape2} alt="Decorative Shape2" className="decorative-shapetwo"/> 
         </div>

        <Card className='resultcard'>
            <CardContent className='resultcontent'>
              <Grid xs={12} className='resultgrid1'>
                <Grid xs={4} className='personname'>
                {/* <img src={imgurl.profile} alt="Profile picture"/> */}
                     {/* <p>Mr.Robert Kim</p> */}
                     {/* <p>Dear user</p> */}
                </Grid>
                <Grid xs={4} className='diagnosis'>
                 <p><span>You've been detected with</span><br />{capitalizeFirstLetter(stage)} Male Pattern Hair Loss</p>
                </Grid>
                <Grid xs={4} className='duration'>
                <p><span>Treatment duration</span><br /> <p className='durationtxt'>6-Months</p></p>
                </Grid>
              </Grid>

              <div className='possibiltydiv'>
                    <p>Hair regrowth probability {norwoodHamiltonStages[stage]['possibility']}</p>
                </div>

              <Grid xs={12} className='resultgrid2'>
                <Grid xs={6} className='detailsgrid'>
                    <div className='details'>
                        {/* <p>
                        Stage 3 male pattern hair loss is marked by minor hair thinning at the crown or front of your head.<br /> <br /> Hair follicle damage is very mild at this stage and can be easily stopped from progressing further if treatment is started early.
                        </p> */}
                        <p>
                          {norwoodHamiltonStages[stage]['description']}
                        </p>
                    </div>
                </Grid>
                {/* <p className='facts'>*Based on 60699 men treated at Alopexia that match this profile</p>

                <Grid xs={6} className='causesgrid'>
                    <Grid xs={2} className='hairlosscause'>
                        <p>Your Hair Loss Root Causes</p>
                    </Grid>

                    <div className='causeboxes'>
                    <Grid xs={2} className='box1'>
                    <img src={imgurl.nutrition} alt="Nutrition"/>
                        <p>Nutrition</p>
                    </Grid>
                    <Grid xs={2} className='box2'>
                    <img src={imgurl.lifestyle} alt="Lifestyle"/>
                        <p>Lifestyle</p>
                    </Grid>
                    </div>
                    
                </Grid> */}
              </Grid>
             
            </CardContent>
        </Card>


        <Grid  className="btnssection">
 <Grid item xs={6}>
 <div className="prevbtn">
      <Button variant="contained" onClick={() => navigate('/taketest')}>
        <div className="prevbtntext"> 
        <img src={imgurl.backarrow} alt="Backward arrows"/>
          <p> Previous </p>
          </div>
      
        </Button>
      </div>
     </Grid>
     <Grid item xs={6}>
     <div className="nextbtn">
      <Button variant="contained" onClick={() => navigate('/prescupld')}>
        <div className="nextbtntext"> 
          <p> Next </p>
          <img src={imgurl.arrows} alt="Forward arrows"/>
          </div>
      
        </Button>
      </div>
     </Grid>
        </Grid>

        <div className='shapeblue'>
        <img src={imgurl.shapeblue} alt="Blue shape"/>
        </div>
      
    </div>
  )
}

export default Result
